/* */ 
"use strict";
var __extends = (this && this.__extends) || function(d, b) {
  for (var p in b)
    if (b.hasOwnProperty(p))
      d[p] = b[p];
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var lang_1 = require('./facade/lang');
var collection_1 = require('./facade/collection');
var template_ast_1 = require('./template_ast');
var compile_metadata_1 = require('./compile_metadata');
var identifiers_1 = require('./identifiers');
var parse_util_1 = require('./parse_util');
var ProviderError = (function(_super) {
  __extends(ProviderError, _super);
  function ProviderError(message, span) {
    _super.call(this, span, message);
  }
  return ProviderError;
}(parse_util_1.ParseError));
exports.ProviderError = ProviderError;
var ProviderViewContext = (function() {
  function ProviderViewContext(component, sourceSpan) {
    var _this = this;
    this.component = component;
    this.sourceSpan = sourceSpan;
    this.errors = [];
    this.viewQueries = _getViewQueries(component);
    this.viewProviders = new compile_metadata_1.CompileTokenMap();
    _normalizeProviders(component.viewProviders, sourceSpan, this.errors).forEach(function(provider) {
      if (lang_1.isBlank(_this.viewProviders.get(provider.token))) {
        _this.viewProviders.add(provider.token, true);
      }
    });
  }
  return ProviderViewContext;
}());
exports.ProviderViewContext = ProviderViewContext;
var ProviderElementContext = (function() {
  function ProviderElementContext(_viewContext, _parent, _isViewRoot, _directiveAsts, attrs, refs, _sourceSpan) {
    var _this = this;
    this._viewContext = _viewContext;
    this._parent = _parent;
    this._isViewRoot = _isViewRoot;
    this._directiveAsts = _directiveAsts;
    this._sourceSpan = _sourceSpan;
    this._transformedProviders = new compile_metadata_1.CompileTokenMap();
    this._seenProviders = new compile_metadata_1.CompileTokenMap();
    this._hasViewContainer = false;
    this._attrs = {};
    attrs.forEach(function(attrAst) {
      return _this._attrs[attrAst.name] = attrAst.value;
    });
    var directivesMeta = _directiveAsts.map(function(directiveAst) {
      return directiveAst.directive;
    });
    this._allProviders = _resolveProvidersFromDirectives(directivesMeta, _sourceSpan, _viewContext.errors);
    this._contentQueries = _getContentQueries(directivesMeta);
    var queriedTokens = new compile_metadata_1.CompileTokenMap();
    this._allProviders.values().forEach(function(provider) {
      _this._addQueryReadsTo(provider.token, queriedTokens);
    });
    refs.forEach(function(refAst) {
      _this._addQueryReadsTo(new compile_metadata_1.CompileTokenMetadata({value: refAst.name}), queriedTokens);
    });
    if (lang_1.isPresent(queriedTokens.get(identifiers_1.identifierToken(identifiers_1.Identifiers.ViewContainerRef)))) {
      this._hasViewContainer = true;
    }
    this._allProviders.values().forEach(function(provider) {
      var eager = provider.eager || lang_1.isPresent(queriedTokens.get(provider.token));
      if (eager) {
        _this._getOrCreateLocalProvider(provider.providerType, provider.token, true);
      }
    });
  }
  ProviderElementContext.prototype.afterElement = function() {
    var _this = this;
    this._allProviders.values().forEach(function(provider) {
      _this._getOrCreateLocalProvider(provider.providerType, provider.token, false);
    });
  };
  Object.defineProperty(ProviderElementContext.prototype, "transformProviders", {
    get: function() {
      return this._transformedProviders.values();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ProviderElementContext.prototype, "transformedDirectiveAsts", {
    get: function() {
      var sortedProviderTypes = this._transformedProviders.values().map(function(provider) {
        return provider.token.identifier;
      });
      var sortedDirectives = collection_1.ListWrapper.clone(this._directiveAsts);
      collection_1.ListWrapper.sort(sortedDirectives, function(dir1, dir2) {
        return sortedProviderTypes.indexOf(dir1.directive.type) - sortedProviderTypes.indexOf(dir2.directive.type);
      });
      return sortedDirectives;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ProviderElementContext.prototype, "transformedHasViewContainer", {
    get: function() {
      return this._hasViewContainer;
    },
    enumerable: true,
    configurable: true
  });
  ProviderElementContext.prototype._addQueryReadsTo = function(token, queryReadTokens) {
    this._getQueriesFor(token).forEach(function(query) {
      var queryReadToken = lang_1.isPresent(query.read) ? query.read : token;
      if (lang_1.isBlank(queryReadTokens.get(queryReadToken))) {
        queryReadTokens.add(queryReadToken, true);
      }
    });
  };
  ProviderElementContext.prototype._getQueriesFor = function(token) {
    var result = [];
    var currentEl = this;
    var distance = 0;
    var queries;
    while (currentEl !== null) {
      queries = currentEl._contentQueries.get(token);
      if (lang_1.isPresent(queries)) {
        collection_1.ListWrapper.addAll(result, queries.filter(function(query) {
          return query.descendants || distance <= 1;
        }));
      }
      if (currentEl._directiveAsts.length > 0) {
        distance++;
      }
      currentEl = currentEl._parent;
    }
    queries = this._viewContext.viewQueries.get(token);
    if (lang_1.isPresent(queries)) {
      collection_1.ListWrapper.addAll(result, queries);
    }
    return result;
  };
  ProviderElementContext.prototype._getOrCreateLocalProvider = function(requestingProviderType, token, eager) {
    var _this = this;
    var resolvedProvider = this._allProviders.get(token);
    if (lang_1.isBlank(resolvedProvider) || ((requestingProviderType === template_ast_1.ProviderAstType.Directive || requestingProviderType === template_ast_1.ProviderAstType.PublicService) && resolvedProvider.providerType === template_ast_1.ProviderAstType.PrivateService) || ((requestingProviderType === template_ast_1.ProviderAstType.PrivateService || requestingProviderType === template_ast_1.ProviderAstType.PublicService) && resolvedProvider.providerType === template_ast_1.ProviderAstType.Builtin)) {
      return null;
    }
    var transformedProviderAst = this._transformedProviders.get(token);
    if (lang_1.isPresent(transformedProviderAst)) {
      return transformedProviderAst;
    }
    if (lang_1.isPresent(this._seenProviders.get(token))) {
      this._viewContext.errors.push(new ProviderError("Cannot instantiate cyclic dependency! " + token.name, this._sourceSpan));
      return null;
    }
    this._seenProviders.add(token, true);
    var transformedProviders = resolvedProvider.providers.map(function(provider) {
      var transformedUseValue = provider.useValue;
      var transformedUseExisting = provider.useExisting;
      var transformedDeps;
      if (lang_1.isPresent(provider.useExisting)) {
        var existingDiDep = _this._getDependency(resolvedProvider.providerType, new compile_metadata_1.CompileDiDependencyMetadata({token: provider.useExisting}), eager);
        if (lang_1.isPresent(existingDiDep.token)) {
          transformedUseExisting = existingDiDep.token;
        } else {
          transformedUseExisting = null;
          transformedUseValue = existingDiDep.value;
        }
      } else if (lang_1.isPresent(provider.useFactory)) {
        var deps = lang_1.isPresent(provider.deps) ? provider.deps : provider.useFactory.diDeps;
        transformedDeps = deps.map(function(dep) {
          return _this._getDependency(resolvedProvider.providerType, dep, eager);
        });
      } else if (lang_1.isPresent(provider.useClass)) {
        var deps = lang_1.isPresent(provider.deps) ? provider.deps : provider.useClass.diDeps;
        transformedDeps = deps.map(function(dep) {
          return _this._getDependency(resolvedProvider.providerType, dep, eager);
        });
      }
      return _transformProvider(provider, {
        useExisting: transformedUseExisting,
        useValue: transformedUseValue,
        deps: transformedDeps
      });
    });
    transformedProviderAst = _transformProviderAst(resolvedProvider, {
      eager: eager,
      providers: transformedProviders
    });
    this._transformedProviders.add(token, transformedProviderAst);
    return transformedProviderAst;
  };
  ProviderElementContext.prototype._getLocalDependency = function(requestingProviderType, dep, eager) {
    if (eager === void 0) {
      eager = null;
    }
    if (dep.isAttribute) {
      var attrValue = this._attrs[dep.token.value];
      return new compile_metadata_1.CompileDiDependencyMetadata({
        isValue: true,
        value: lang_1.normalizeBlank(attrValue)
      });
    }
    if (lang_1.isPresent(dep.query) || lang_1.isPresent(dep.viewQuery)) {
      return dep;
    }
    if (lang_1.isPresent(dep.token)) {
      if ((requestingProviderType === template_ast_1.ProviderAstType.Directive || requestingProviderType === template_ast_1.ProviderAstType.Component)) {
        if (dep.token.equalsTo(identifiers_1.identifierToken(identifiers_1.Identifiers.Renderer)) || dep.token.equalsTo(identifiers_1.identifierToken(identifiers_1.Identifiers.ElementRef)) || dep.token.equalsTo(identifiers_1.identifierToken(identifiers_1.Identifiers.ChangeDetectorRef)) || dep.token.equalsTo(identifiers_1.identifierToken(identifiers_1.Identifiers.TemplateRef))) {
          return dep;
        }
        if (dep.token.equalsTo(identifiers_1.identifierToken(identifiers_1.Identifiers.ViewContainerRef))) {
          this._hasViewContainer = true;
        }
      }
      if (dep.token.equalsTo(identifiers_1.identifierToken(identifiers_1.Identifiers.Injector))) {
        return dep;
      }
      if (lang_1.isPresent(this._getOrCreateLocalProvider(requestingProviderType, dep.token, eager))) {
        return dep;
      }
    }
    return null;
  };
  ProviderElementContext.prototype._getDependency = function(requestingProviderType, dep, eager) {
    if (eager === void 0) {
      eager = null;
    }
    var currElement = this;
    var currEager = eager;
    var result = null;
    if (!dep.isSkipSelf) {
      result = this._getLocalDependency(requestingProviderType, dep, eager);
    }
    if (dep.isSelf) {
      if (lang_1.isBlank(result) && dep.isOptional) {
        result = new compile_metadata_1.CompileDiDependencyMetadata({
          isValue: true,
          value: null
        });
      }
    } else {
      while (lang_1.isBlank(result) && lang_1.isPresent(currElement._parent)) {
        var prevElement = currElement;
        currElement = currElement._parent;
        if (prevElement._isViewRoot) {
          currEager = false;
        }
        result = currElement._getLocalDependency(template_ast_1.ProviderAstType.PublicService, dep, currEager);
      }
      if (lang_1.isBlank(result)) {
        if (!dep.isHost || this._viewContext.component.type.isHost || identifiers_1.identifierToken(this._viewContext.component.type).equalsTo(dep.token) || lang_1.isPresent(this._viewContext.viewProviders.get(dep.token))) {
          result = dep;
        } else {
          result = dep.isOptional ? result = new compile_metadata_1.CompileDiDependencyMetadata({
            isValue: true,
            value: null
          }) : null;
        }
      }
    }
    if (lang_1.isBlank(result)) {
      this._viewContext.errors.push(new ProviderError("No provider for " + dep.token.name, this._sourceSpan));
    }
    return result;
  };
  return ProviderElementContext;
}());
exports.ProviderElementContext = ProviderElementContext;
function _transformProvider(provider, _a) {
  var useExisting = _a.useExisting,
      useValue = _a.useValue,
      deps = _a.deps;
  return new compile_metadata_1.CompileProviderMetadata({
    token: provider.token,
    useClass: provider.useClass,
    useExisting: useExisting,
    useFactory: provider.useFactory,
    useValue: useValue,
    deps: deps,
    multi: provider.multi
  });
}
function _transformProviderAst(provider, _a) {
  var eager = _a.eager,
      providers = _a.providers;
  return new template_ast_1.ProviderAst(provider.token, provider.multiProvider, provider.eager || eager, providers, provider.providerType, provider.sourceSpan);
}
function _normalizeProviders(providers, sourceSpan, targetErrors, targetProviders) {
  if (targetProviders === void 0) {
    targetProviders = null;
  }
  if (lang_1.isBlank(targetProviders)) {
    targetProviders = [];
  }
  if (lang_1.isPresent(providers)) {
    providers.forEach(function(provider) {
      if (lang_1.isArray(provider)) {
        _normalizeProviders(provider, sourceSpan, targetErrors, targetProviders);
      } else {
        var normalizeProvider;
        if (provider instanceof compile_metadata_1.CompileProviderMetadata) {
          normalizeProvider = provider;
        } else if (provider instanceof compile_metadata_1.CompileTypeMetadata) {
          normalizeProvider = new compile_metadata_1.CompileProviderMetadata({
            token: new compile_metadata_1.CompileTokenMetadata({identifier: provider}),
            useClass: provider
          });
        } else {
          targetErrors.push(new ProviderError("Unknown provider type " + provider, sourceSpan));
        }
        if (lang_1.isPresent(normalizeProvider)) {
          targetProviders.push(normalizeProvider);
        }
      }
    });
  }
  return targetProviders;
}
function _resolveProvidersFromDirectives(directives, sourceSpan, targetErrors) {
  var providersByToken = new compile_metadata_1.CompileTokenMap();
  directives.forEach(function(directive) {
    var dirProvider = new compile_metadata_1.CompileProviderMetadata({
      token: new compile_metadata_1.CompileTokenMetadata({identifier: directive.type}),
      useClass: directive.type
    });
    _resolveProviders([dirProvider], directive.isComponent ? template_ast_1.ProviderAstType.Component : template_ast_1.ProviderAstType.Directive, true, sourceSpan, targetErrors, providersByToken);
  });
  var directivesWithComponentFirst = directives.filter(function(dir) {
    return dir.isComponent;
  }).concat(directives.filter(function(dir) {
    return !dir.isComponent;
  }));
  directivesWithComponentFirst.forEach(function(directive) {
    _resolveProviders(_normalizeProviders(directive.providers, sourceSpan, targetErrors), template_ast_1.ProviderAstType.PublicService, false, sourceSpan, targetErrors, providersByToken);
    _resolveProviders(_normalizeProviders(directive.viewProviders, sourceSpan, targetErrors), template_ast_1.ProviderAstType.PrivateService, false, sourceSpan, targetErrors, providersByToken);
  });
  return providersByToken;
}
function _resolveProviders(providers, providerType, eager, sourceSpan, targetErrors, targetProvidersByToken) {
  providers.forEach(function(provider) {
    var resolvedProvider = targetProvidersByToken.get(provider.token);
    if (lang_1.isPresent(resolvedProvider) && resolvedProvider.multiProvider !== provider.multi) {
      targetErrors.push(new ProviderError("Mixing multi and non multi provider is not possible for token " + resolvedProvider.token.name, sourceSpan));
    }
    if (lang_1.isBlank(resolvedProvider)) {
      resolvedProvider = new template_ast_1.ProviderAst(provider.token, provider.multi, eager, [provider], providerType, sourceSpan);
      targetProvidersByToken.add(provider.token, resolvedProvider);
    } else {
      if (!provider.multi) {
        collection_1.ListWrapper.clear(resolvedProvider.providers);
      }
      resolvedProvider.providers.push(provider);
    }
  });
}
function _getViewQueries(component) {
  var viewQueries = new compile_metadata_1.CompileTokenMap();
  if (lang_1.isPresent(component.viewQueries)) {
    component.viewQueries.forEach(function(query) {
      return _addQueryToTokenMap(viewQueries, query);
    });
  }
  component.type.diDeps.forEach(function(dep) {
    if (lang_1.isPresent(dep.viewQuery)) {
      _addQueryToTokenMap(viewQueries, dep.viewQuery);
    }
  });
  return viewQueries;
}
function _getContentQueries(directives) {
  var contentQueries = new compile_metadata_1.CompileTokenMap();
  directives.forEach(function(directive) {
    if (lang_1.isPresent(directive.queries)) {
      directive.queries.forEach(function(query) {
        return _addQueryToTokenMap(contentQueries, query);
      });
    }
    directive.type.diDeps.forEach(function(dep) {
      if (lang_1.isPresent(dep.query)) {
        _addQueryToTokenMap(contentQueries, dep.query);
      }
    });
  });
  return contentQueries;
}
function _addQueryToTokenMap(map, query) {
  query.selectors.forEach(function(token) {
    var entry = map.get(token);
    if (lang_1.isBlank(entry)) {
      entry = [];
      map.add(token, entry);
    }
    entry.push(query);
  });
}
